// ----------------------------------------------------------------------------
// Section: Featured Collection
// ----------------------------------------------------------------------------
//
// This is a section that displays featured collection items and optional button
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { Scrollbar, A11y } from 'swiper';
import '../../snippets/card/card';
import '../../snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import './_featured-collection.scss';


// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------

// window.onscroll = function() {
//     let backgroundText = document.querySelector('.featured-collection_background-text');
//     let pos = window.scrollY - 800;
//     backgroundText.style.left = pos + 'px';

// }

// let backgroundText = document.querySelector('.featured-collection_background-text');

// document.addEventListener('scroll', function(){
//     let textOffset = backgroundText.offsetTop;

//     console.log(textOffset);
//     console.log(textOffset - window.scrollY);

//     backgroundText.style.left = Math.max( 50, ( window.innerWidth / 10000 ) * window.scrollY ) + '%';
// });


function handleSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiperEl.slideTo(index);
        })
    });
}

$(function() {
    $(".carousel--featured-collection").each(function(index, element){
    var $this = $(this);

    // Generate unique class for each feature collection slider
    $this.addClass("featured-collection-instance-" + index);

    // Generate unique btn classes for slider arrows
    $this.parents('.featured-collection').find(".swiper-scrollbar").addClass("featured-collection-swiper-scrollbar-" + index);
    $this.parents('.featured-collection').find(".swiper-button-next").addClass("featured-collection-btn-next-" + index);

    // Initialize feature collection slider based on the unique classes generated above.
    var swiper = new Swiper(".featured-collection-instance-" + index, {
        // Optional parameters
        modules: [Scrollbar, A11y],
        slidesPerView: 1.6,
        spaceBetween: 20,
        observer: true,
        observeParents: true,
        a11y: false,
        watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

        breakpoints: {
          // when window width is >= 680px
          680: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 30
          }

        },

        // // // Navigation arrows
        // navigation: {
        //   nextEl: ".featured-collection-btn-next-" + index,
        //   prevEl: ".featured-collection-btn-prev-" + index
        // }
        // // Navigation arrows
        scrollbar: {
            el: ".featured-collection-swiper-scrollbar-" + index,
            draggable: true,
        }
    });

    swiper.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiper.slideTo(index);
        })
    });
  });
});
